import './interaction_view.js.coffee'
Customer.Ticket ||= {}

class Customer.Ticket.WhatsappInteractionView extends Customer.Ticket.InteractionView

  initialize: (@options = {}) ->
    super(@options)
    @events['click .sc-wscontact-see-more'] = '_collapseContactCard'
    @delegateEvents()

  render: (avoidDuplications = true) ->
    super(avoidDuplications)
    @whatsappAudioManager = new Monitoring.Views.WhatsappAudioControlsManager(@$el.find('.player-container'))
    @whatsappAudioManager._initWhatsappAudioControls()
    @_renderFullSizePopups()
    @

  _initRetryButtons: ->
    @$el.find('.retry_icon').each (index, element) ->
      current_element = $(this)
      current_element.click ->
        data_msg_id_selector = '[data-msg-id='+ current_element.attr("data-rel-msg-id") + ']';
        data_elem_container = current_element.parent().parent().find(data_msg_id_selector)
        alert("In construction: Reply using text: " + data_elem_container.attr("data-msg-text") + " and media from this url: " + data_elem_container.attr("data-msg-url"))

  _renderFullSizePopups: ->
    @$el.find('.sc-picture-preview').magnificPopup(type: 'image', closeOnContentClick: true)
    @$el.find('.sc-video-preview').magnificPopup(type: 'iframe', closeOnContentClick: true)



  _collapseContactCard: (event)->
    $seeMore = $(event.target)
    $container = $seeMore.closest('.whatsapp-contact-container').toggleClass 'sc-wscontact-collapsed'
    $seeMore.text(I18n.t("monitoring.dashboard.social_content.#{
    if $container.hasClass('sc-wscontact-collapsed') then 'see_more' else 'see_less'
    }"))
    false
